
import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
    return (
        <>
            <div className="container-fluid contact mt-3">
                <div className="row">
                    <div className="col-10 mx-auto">
                        <div className="row">
                            <div className="col-md-12 mt-1">
                                {/* <Alert severity="info">
                                    {'TERMS STATEMENT'}<br />
                                    {'Datum: 09-DEC-2021'}
                                </Alert> */}
                            </div>
                            <div className="col-md-10 mt-5 fontStyle fontStyleTerms">
                                <h2>Privacy Policy</h2>

                                <p>This Privacy Policy outlines how Kaipsool Pharmatech collects, uses, and safeguards your personal information. We are committed to ensuring the privacy and security of your data while providing a seamless user experience.</p>
                                
                                <h5 className="mt-4 mb-3">Information We Collect:</h5>
                                <ol>
                                    <li>Personal Information: We may collect names, contact details, and location data to personalize user experiences, facilitate medical searches, provide discounts, and promote events.</li>
                                    <li>Automatically Collected Information: We gather data through cookies and similar technologies to enhance our services and user interactions.</li>
                                </ol>

                                <h5 className="mt-4 mb-3">How We Use Your Information:</h5>
                                <ol>
                                    <li>Improving Services: We use collected information to enhance our platform, provide personalized content, and improve user experiences.</li>
                                    <li>Promoting Events and Discounts: Your data allows us to inform you about pharmaceutical events, promotions, and discounts that match your preferences.</li>
                                </ol>

                                <h5 className="mt-4 mb-3">Data Security:</h5>
                                <ul>
                                    <li>Kaipsool Pharmatech employs industry-standard security measures to protect your information from unauthorized access, disclosure, alteration, or destruction. We take data security seriously and prioritize its protection.</li>
                                </ul> 

                                <h5 className="mt-4 mb-3">Information Sharing:</h5>
                                <ul>
                                    <li>We do not sell or rent your personal information to third parties. However, we may share data with trusted partners, service providers, and affiliated companies to improve our services, subject to strict confidentiality agreements.</li>
                                </ul>   

                                <h5 className="mt-4 mb-3">Legal Compliance:</h5>
                                <ul>
                                    <li>Users are expected to comply with all applicable laws when using our platform. We do not endorse any illegal activities or misuse of our services for unlawful purposes.</li>
                                </ul>

                                <h5 className="mt-4 mb-3">Updates to Privacy Policy:</h5>
                                <ul>
                                    <li>We may periodically update our Privacy Policy to reflect changes in services or legal requirements. Check this page for updates. Your continued use of our platform indicates acceptance of any revised Privacy Policy.</li>
                                </ul>                          
                                <br /><br />
                                

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PrivacyPolicy
